import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchEventLanguages, fetchEvents } from 'src/api/event';
import {
    FETCH_EVENTS,
    FETCH_EVENT_LANGUAGES,
    requestEventLanguages,
    requestEventLanguagesFailure,
    requestEventLanguagesSuccess,
    requestEvents,
    requestEventsFailure,
    requestEventsSuccess,
} from './actions';

/* Events */
function* fetchEventsSaga(action: AnyAction): SagaIterator {
    yield put(requestEvents());

    const { error, response } = yield call(fetchEvents, action.pageable);

    if (error) yield put(requestEventsFailure(error));
    else yield put(requestEventsSuccess(response));
}

export function* generateFetchEventsWatcher() {
    yield takeLatest(FETCH_EVENTS, fetchEventsSaga);
}

/* Event Languages */
function* fetchEventLanguagesSaga(action: AnyAction): SagaIterator {
    yield put(requestEventLanguages());

    const { error, response } = yield call(fetchEventLanguages);

    if (error) yield put(requestEventLanguagesFailure(error));
    else yield put(requestEventLanguagesSuccess(response));
}

export function* generateFetchEventLanguagesWatcher() {
    yield takeLatest(FETCH_EVENT_LANGUAGES, fetchEventLanguagesSaga);
}
